import React from 'react'

interface GarbageBinProps {
  className?: string
}

const GarbageBin: React.FC<GarbageBinProps> = ({
  className,
}: GarbageBinProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.70058 1.04199C7.71418 1.04199 6.83844 1.67319 6.52651 2.60897L6.21551 3.54199L3.34234 3.54199H3.32449L1.66602 3.54199C1.32084 3.54199 1.04102 3.82181 1.04102 4.16699C1.04102 4.51217 1.32084 4.79199 1.66602 4.79199H2.77686L4.03225 15.4628C4.26678 17.4563 5.95626 18.9587 7.96347 18.9587H12.0351C14.0424 18.9587 15.7318 17.4563 15.9664 15.4628L17.2218 4.79199H18.3327C18.6779 4.79199 18.9577 4.51217 18.9577 4.16699C18.9577 3.82181 18.6779 3.54199 18.3327 3.54199L16.674 3.54199H16.6564L13.7831 3.54199L13.4721 2.60897C13.1602 1.67319 12.2845 1.04199 11.2981 1.04199H8.70058ZM13.318 4.79199C13.3277 4.79222 13.3374 4.79222 13.3471 4.79199L15.9631 4.79199L14.7249 15.3168C14.5645 16.6807 13.4085 17.7087 12.0351 17.7087H7.96347C6.59011 17.7087 5.43415 16.6807 5.27369 15.3168L4.03548 4.79199L6.65154 4.79199C6.66125 4.79222 6.67094 4.79222 6.6806 4.79199L13.318 4.79199ZM12.4655 3.54199L12.2863 3.00426C12.1445 2.5789 11.7464 2.29199 11.2981 2.29199H8.70058C8.25222 2.29199 7.85415 2.5789 7.71237 3.00426L7.53312 3.54199L12.4655 3.54199ZM8.95768 8.33366C8.95768 7.98848 8.67786 7.70866 8.33268 7.70866C7.9875 7.70866 7.70768 7.98848 7.70768 8.33366V13.3337C7.70768 13.6788 7.9875 13.9587 8.33268 13.9587C8.67786 13.9587 8.95768 13.6788 8.95768 13.3337V8.33366ZM11.666 7.70866C12.0112 7.70866 12.291 7.98848 12.291 8.33366V13.3337C12.291 13.6788 12.0112 13.9587 11.666 13.9587C11.3208 13.9587 11.041 13.6788 11.041 13.3337V8.33366C11.041 7.98848 11.3208 7.70866 11.666 7.70866Z"
      fill="#252324"
    />
  </svg>
)

export default GarbageBin
